export default {
  properties: {
    caseId: {
      type: 'number',
      title: 'Identyfikator sprawy MDOK'
    }
  },
  type: 'object'
};
